







import Vue from "vue";
import ColoredCurrencyTextField from "@/components/ColoredCurrencyTextField.vue";

export default Vue.extend({
    components: {
        ColoredCurrencyTextField,
    },
    props: {
        datasets: Array,
        filters: Object,
    },
    computed: {
        isCurrencyVulue() {
            return this.filters && this.filters.currency && this.filters.currency.length > 0;
        },
        numberValue() {
            var res = null;

            if (this.datasets && this.datasets.length > 0) {
                if (this.datasets[0].data && this.datasets[0].data.length > 0) res = this.datasets[0].data[0];
            }

            return res;
        },
    },
});
